import React from "react";

export interface AutoplaySwitchProps {
  /** Controlled checked state */
  checked: boolean;
  /** Called when the switch is toggled (only the switch control is clickable, not the label) */
  onChange: (checked: boolean) => void;
  /** When true, switch is disabled and rendered in grey */
  disabled?: boolean;
  /** Optional label shown next to the switch (e.g. "Autoplay is on" / "Autoplay is off"). Not clickable. */
  label?: React.ReactNode;
  /** Input id for accessibility; defaults to a unique id if not provided */
  id?: string;
  /** Optional class name for the wrapper */
  className?: string;
  /** Optional inline styles for the wrapper */
  style?: React.CSSProperties;
}

function AutoplaySwitch({
  checked,
  onChange,
  disabled = false,
  label,
  id = "autoplay-switch",
  className = "",
  style,
}: AutoplaySwitchProps) {
  return (
    <div
      className={`content-autoplay-switch d-flex align-items-center justify-content-end w-100 mb-2 ${className}`.trim()}
      style={style}
    >
      <div className="form-check form-switch mb-0">
        <input
          className="form-check-input"
          type="checkbox"
          id={id}
          role="switch"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        {label != null && (
          <span className="content-autoplay-switch__label ms-2">{label}</span>
        )}
      </div>
    </div>
  );
}

export default AutoplaySwitch;
